import { createContext, useContext } from 'react'

interface Subscription {
  id: string
  product: string
  provider_product: string
  status: string
}

const DEFAULT_PRODUCT = 'free'
const DEFAULT_STATUS = 'active'
const DEFAULT_SUBSCRIPTION: Subscription = {
  product: DEFAULT_PRODUCT,
  status: DEFAULT_STATUS,
  provider_product: '',
  id: '',
}

export interface BillingAccount {
  id: string
  email: string
  provider_id: string
  cycle_start_day: number
  cycle_chat_interactions: number
  cycle_chat_conversations: number
  subscription: Subscription
  referral_code?: string
}

export function asBillingAccount(data: BillingAccount): BillingAccount {
  return {
    ...data,
    subscription: data.subscription || DEFAULT_SUBSCRIPTION,
  }
}

interface SubscriptionContextType {
  billingAccount: BillingAccount
  setBillingAccount: (billingAccount: BillingAccount) => void
}

export const SubscriptionContext =
  createContext<SubscriptionContextType | null>(null)

export function useSubscription() {
  const context = useContext(SubscriptionContext)
  if (!context) {
    throw new Error(
      'useSubscription must be used within a SubscriptionProvider',
    )
  }
  return context
}
